import { render, staticRenderFns } from "./Admon.vue?vue&type=template&id=04201520&"
import script from "./Admon.vue?vue&type=script&lang=js&"
export * from "./Admon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports